import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

export default {
  description: {
    title: <FormattedMessage {...messages['title']} />,
    filterLabel: <FormattedMessage {...messages['filterLabel']} />,
    locationLabel: <FormattedMessage {...messages['locationLabel']} />,
    previousPage: <FormattedMessage {...messages['previousPage']} />,
    nextPage: <FormattedMessage {...messages['nextPage']} />,
    emea: <FormattedMessage {...messages['emea']} />,
    apac: <FormattedMessage {...messages['apac']} />,
    americas: <FormattedMessage {...messages['americas']} />,
  },
  legends: [
    {
      title: <FormattedMessage {...messages['firstTitle']} />,
      type: 'multi-zone',
    },
    {
      title: <FormattedMessage {...messages['secondTitle']} />,
      type: 'data-centers',
    },
    {
      title: <FormattedMessage {...messages['thirdTitle']} />,
      type: 'federal-data-center',
    },
    {
      title: <FormattedMessage {...messages['fourthTitle']} />,
      type: 'network-pop',
    },
  ],
  groups: [
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row1']} />,
      types: [
        'data-centers',
        'network-pop',
        'federal-data-center',
        'multi-zone',
      ],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row2']} />,
      types: [
        'network-pop',
        'data-centers',
        'federal-data-center',
        'multi-zone',
      ],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row3']} />,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row5']} />,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row6']} />,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row7']} />,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row8']} />,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row9']} />,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row10']} />,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: <FormattedMessage {...messages['row11']} />,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'CA',
      city: <FormattedMessage {...messages['row12']} />,
      types: ['multi-zone', 'data-centers', 'network-pop'],
    },
    {
      region: 'Americas',
      country: 'CA',
      city: <FormattedMessage {...messages['row13']} />,
      types: ['multi-zone', 'data-centers', 'network-pop'],
    },
    {
      region: 'Americas',
      country: 'BR',
      city: <FormattedMessage {...messages['row14']} />,
      types: ['multi-zone', 'data-centers', 'network-pop'],
    },
    {
      //europe
      region: 'EMEA',
      country: 'DE',
      city: <FormattedMessage {...messages['row15']} />,
      types: ['network-pop', 'data-centers', 'multi-zone'],
    },
    {
      region: 'EMEA',
      country: 'ES',
      city: <FormattedMessage {...messages['row16']} />,
      types: ['multi-zone', 'data-centers', 'network-pop'],
    },
    {
      region: 'EMEA',
      country: 'UK',
      city: <FormattedMessage {...messages['row17']} />,
      types: ['network-pop', 'data-centers', 'multi-zone'],
    },
    {
      region: 'EMEA',
      country: 'FR',
      city: <FormattedMessage {...messages['row18']} />,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'EMEA',
      country: 'NO',
      city: <FormattedMessage {...messages['oslo']} />,
      types: ['network-pop'],
    },
    {
      region: 'EMEA',
      country: 'SWE',
      city: <FormattedMessage {...messages['stockholm']} />,
      types: ['network-pop'],
    },
    {
      region: 'EMEA',
      country: 'NL',
      city: <FormattedMessage {...messages['row19']} />,
      types: ['network-pop', 'data-centers'],
    },
    {
      region: 'EMEA',
      country: 'IT',
      city: <FormattedMessage {...messages['row20']} />,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'APAC',
      country: 'JP',
      city: <FormattedMessage {...messages['row21']} />,
      types: ['network-pop', 'multi-zone', 'data-centers'],
    },
    {
      region: 'APAC',
      country: 'JP',
      city: <FormattedMessage {...messages['row22']} />,
      types: ['network-pop', 'multi-zone', 'data-centers'],
    },
    {
      region: 'APAC',
      country: 'GCG',
      city: <FormattedMessage {...messages['row23']} />,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'TW',
      city: <FormattedMessage {...messages['row24']} />,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'KR',
      city: <FormattedMessage {...messages['row25']} />,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'SG',
      city: <FormattedMessage {...messages['row26']} />,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'APAC',
      country: 'IN',
      city: <FormattedMessage {...messages['row27']} />,
      types: ['data-centers'],
    },
    {
      region: 'APAC',
      country: 'IN',
      city: <FormattedMessage {...messages['row28']} />,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'AU',
      city: <FormattedMessage {...messages['row29']} />,
      types: ['multi-zone', 'network-pop', 'data-centers'],
    },
    {
      region: 'APAC',
      country: 'AU',
      city: <FormattedMessage {...messages['row30']} />,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'AU',
      city: <FormattedMessage {...messages['row31']} />,
      types: ['network-pop'],
    },
  ],
};
